import React from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useTranslation } from "../../i18n/I18nContext";

/**
 * Aviso fixo no topo da página, mostrado enquanto `isOnline` for false.
 * Combinado com a classe `app-offline` (ver MasterLayout e extra.css), que
 * bloqueia os botões de acção enquanto não houver ligação à internet.
 */
const OfflineBanner = ({ isOnline }) => {
  const { t } = useTranslation();

  if (isOnline) return null;

  return (
    <div
      className='alert alert-warning d-flex align-items-center justify-content-center gap-2 radius-0 mb-0 py-8 text-center'
      style={{ position: "fixed", top: 0, left: 0, width: "100%", zIndex: 2147483647 }}
      role='alert'
    >
      <Icon icon='mdi:wifi-off' className='text-lg' />
      <span>{t("network.offline.banner")}</span>
    </div>
  );
};

export default OfflineBanner;
